<div class="w-full mb-4">
    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
        {{ label() ?? 'Upload Document' }}
    </label>
    @for (item of notes(); track $index) {
    <p class="text-xs text-primary-300 block">item</p>
    <!-- <p class="text-xs text-primary-300">Image file up to 5 Mb only</p> -->
    }
    <div class="flex flex-row gap-4 mt-2 w-full">
        <div class="rounded h-[130px] grow">
            @if (uppy) {
            <uppy-dashboard [uppy]="uppy!" [props]="dashboardProps"></uppy-dashboard>
            }
        </div>
    </div>
</div>